import { useEffect } from "react";
import { Box, CircularProgress, Grid } from "@mui/material";
import Select from "react-select";
import chroma from "chroma-js";
import "./base-select.scss";

function BaseSelect({
    options,
    optionLabel,
    optionValue,
    value,
    setValue,
    innerRef,
    placeholder,
    search,
    isMulti,
    customFilter,
    menuPlacement,
    loading,
    disable,
    dropdownIndicator,
    icon,
}) {
    useEffect(() => {
        options?.map(item => {
            if (!item?.has_plan) {
                item.color = "#1E1E1E";
            } else {
                item.color = "#006363";
            }
            return item;
        });
    }, [options]);

    //select styles
    const customStyles = {
        indicatorSeparator: () => {}, // removes the "stick"
        dropdownIndicator: defaultStyles => ({
            ...defaultStyles,
            "& svg": { display: dropdownIndicator ? "block" : "none" },
        }),

        control: (defaultStyles, { isFocused }) => ({
            ...defaultStyles,
            borderRadius: isFocused ? "0.625rem 0.625rem 0 0" : "0.625rem",
            height: "3rem",
            padding: "0 1.75rem",
            fontWeight: "bold",
            border: "0.5px solid var(--light-gray-color)",
            backgroundColor: disable ? "var(--white-gray-color)" : "var(--light-color)",
            borderColor: "transparent",
            boxShadow: "none",

            "&:hover": {
                border: "0.5px solid var(--light-gray-color)",
                boxShadow: "none",
            },
        }),

        ValueContainer: (defaultStyles, state) => ({
            ...defaultStyles,
            padding: "0 0",
        }),

        indicatorsContainer: defaultStyles => ({
            ...defaultStyles,
            display: "none !important",
        }),

        singleValue: (defaultStyles, state) => {
            return {
                ...defaultStyles,
                margin: "0 0.5rem",
            };
        },

        menuList: defaultStyles => ({
            ...defaultStyles,
            maxHeight: "15rem",
        }),

        menu: defaultStyles => ({
            ...defaultStyles,
            marginTop: "1px",
            borderRadius: "0 0 0.625rem 0.625rem",
            border: "none",
            zIndex: "9999",
        }),

        option: (defaultStyles, { data, isDisabled, isFocused, isSelected }) => {
            const color = chroma(data?.color);
            return {
                ...defaultStyles,
                padding: "0.5rem 1rem",
                borderBottom: "1px solid var(--light-gray-color)",
                fontWeight: isSelected ? "bold" : "inherit",
                fontSize: "0.875rem",
                backgroundColor: isDisabled ? undefined : isSelected ? data.color : isFocused ? color.alpha(0.1).css() : undefined,
                color: isDisabled ? "var(--medium-gray-color)" : isSelected ? (chroma.contrast(color, "white") > 2 ? "white" : "black") : data.color,
                cursor: isDisabled ? "not-allowed" : "default",

                "&:active": {
                    ...defaultStyles[":active"],
                    backgroundColor: !isDisabled ? (isSelected ? data.color : color.alpha(0.3).css()) : undefined,
                },
                "&:hover": {
                    backgroundColor: isSelected ? "" : "rgb(222, 235, 255)",
                },
                "&:last-child": {
                    borderBottom: "0",
                },
            };
        },

        multiValue: defaultStyles => ({
            ...defaultStyles,
            color: "var(--light-color)",
            backgroundColor: "var(--teal-color-08)",
            borderRadius: "0.625rem",
            "& [class^=css]": { color: "var(--light-color)" },
        }),

        placeholder: defaultStyles => ({
            ...defaultStyles,
            color: disable ? "var(--gray-color)" : "var(--medium-gray-color)",
            margin: "0 0.5rem",
            fontSize: "0.875rem",
        }),
    };

    return (
        <Grid className="select" container item xs={12}>
            <Box className="icon">{icon}</Box>
            <Select
                className={`base-select`}
                options={options}
                defaultValue={value}
                value={value}
                onChange={e => setValue(e)}
                ref={innerRef}
                placeholder={placeholder}
                isClearable
                isSearchable={search}
                isMulti={isMulti}
                openMenuOnFocus={true}
                filterOption={customFilter}
                menuPlacement={menuPlacement}
                isDisabled={disable}
                styles={customStyles}
                isLoading={loading}
                loadingMessage={() => <CircularProgress color="inherit" size={20} />}
                getOptionLabel={item => item?.name}
            />
        </Grid>
    );
}

export default BaseSelect;
